export const handleChangeInputProilePage = (name, value) => ({
    type: 'CHANGE_INPUT_PAGE_PROFILE', name, value
});